import { Injectable } from '@angular/core';
import { Incompatibilities } from '../Incompatibilities';
import { CoolerCpu } from '../model/CoolerCpu';
import { Cpu } from '../model/Cpu';
import { FuncionCompatilibidadBase } from './FuncionesCompatibilidadBase';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

@Injectable({
  providedIn: 'root',
})
export class FC_CpuCoolerCpu extends FuncionCompatilibidadBase<Cpu, CoolerCpu> {
  funciones = {
    /*socket: (cpu: Cpu, coolerCpu: CoolerCpu): Incompatibilities | null =>
      !coolerCpu.$caracteristicas?.sockets.split(',').includes(cpu.$caracteristicas?.tipo)
        ? {
            tipo: IncompatibilitiesType.PRODUCTO,
            incompatibility: 'El socket del cpu no es compatible con el coolercpu'
          }
        : null,*/
    tdp: (cpu: Cpu, coolerCpu: CoolerCpu): Incompatibilities | null => {
      if (coolerCpu.id_producto == 2093 || coolerCpu.id_producto == 2094) return null;
      return +coolerCpu.$caracteristicas?.TDP <= cpu.$caracteristicas?.w ?
          {
            tipo: IncompatibilitiesType.PRODUCTO,
            incompatibility: 'El tdp del cooler no es suficiente para los watts del cpu',
          }
        : null;
    },

    tipoCoolerIncluido: (cpu: Cpu, coolerCpu: CoolerCpu): Incompatibilities | null => {
      const subcateCpuIdCooler = { 27: 2094, 48: 2093 };
      //si el coolerCpu a revisar no es de los incluidos que retorne null
      if (coolerCpu.id_producto != 2093 && coolerCpu.id_producto != 2094) return null;
      //si el cpu no tiene cooler incluido pero el cooler a revisar es de los incluidos => retorna incompatible
      if (!cpu.$caracteristicas.cooler)
        return {
          tipo: IncompatibilitiesType.PRODUCTO,
          incompatibility: 'El cpu no posee cooler incluido',
        };

      //aca solo llega si el cpu tiene cooler y el coolerCpu es 2093 ó 2094
      return subcateCpuIdCooler[cpu.id_subcategoria] != coolerCpu.id_producto ?
          {
            tipo: IncompatibilitiesType.PRODUCTO,
            incompatibility: 'El cpu es incompatible con el cooler cpu por su familia',
          }
        : null;
    },
  };
}
